import { Text } from '@dixa/lib-shared-habla';
import { SearchUserEnriched } from 'lib-search-types';
import { User } from 'lib-shared-types-api';

import { AwayStatus } from 'apis/presence';
import { AddFavoritesDropdown } from 'components/addFavoritesDropdown';
import styles from 'components/presence/components/presenceList.module.scss';
import { PresenceListItem } from 'components/presence/components/presenceListItem';
import { PresenceSectionSkeleton } from 'components/presence/components/presenceSectionSkeleton';

type FavoritesPresenceListSectionProps = {
  profile: User;
  awayStatuses: AwayStatus[];
  members: SearchUserEnriched[];
  loading: boolean;
  favoriteAgentIds: readonly string[];
  onAddToFavorites: (userId: string) => void;
  onRemoveFromFavorites: (userId: string) => void;
  onDropdownOpenChange: (isOpen: boolean) => void;
};

export const FavoritesPresenceListSection = ({
  profile,
  awayStatuses,
  members,
  loading,
  favoriteAgentIds,
  onAddToFavorites,
  onRemoveFromFavorites,
  onDropdownOpenChange,
}: FavoritesPresenceListSectionProps): JSX.Element => {
  if (loading) {
    return <PresenceSectionSkeleton />;
  }

  return (
    <>
      <li className={styles.groupHead}>
        <Text.Paragraph variant="3" color="var(--sidebar-text-color-secondary)">
          Favorites ({members.length})
        </Text.Paragraph>
      </li>
      {members.length > 0 && (
        <ul className={styles.list}>
          {members.map((member) => (
            <PresenceListItem
              key={member.id}
              member={member}
              ownProfile={profile}
              awayStatuses={awayStatuses}
              isFavorite={favoriteAgentIds.includes(member.id)}
              onAddToFavorites={onAddToFavorites}
              onRemoveFromFavorites={onRemoveFromFavorites}
            />
          ))}
        </ul>
      )}
      <AddFavoritesDropdown onOpenChange={onDropdownOpenChange} />
    </>
  );
};
